import angular from "angular";

function dcTimeAgo(moment) {

  return {
    restrict: "E",
    require: 'ngModel',
    scope: {

    },
    template : require("./dc-time-ago.tpl.html"),
    link: function (scope, elem, attrs, ngModel) {

      ngModel.$viewChangeListeners.push(function () {
        scope.$eval(attrs.ngChange);
      });
      ngModel.$render = function () {
        scope.date = moment(ngModel.$modelValue).fromNow(); // LocaleService.formatDate(,"shortDate");
      };

    }
  };

}

export default angular.module("dc-ui.dcTimeAgo",[])
.directive("dcTimeAgo",["moment",dcTimeAgo])
.name;



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-time-ago/dc-time-ago.js